import * as React from 'react';

import { useEnterpriseProgramsByOrganizationSlug } from 'bundles/enterprise-admin-hooks/hooks/useEnterpriseProgramsByOrganizationSlug';
import { useEnterpriseAdminPermissions } from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsProvider';
import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';

/**
 * Groups (programs) the current admin can manage learners in — shared by the "Add to
 * group" and "Assign content" group pickers on the Group Details and All Learners
 * bulk-action bars.
 */
export const useManageableGroups = () => {
  const org = useThirdPartyOrganization();
  const { hasPermission } = useEnterpriseAdminPermissions();
  const { programs } = useEnterpriseProgramsByOrganizationSlug(org.slug, 'LEARNERS');

  return React.useMemo(
    () =>
      (programs ?? []).filter((program) =>
        hasPermission({ domain: 'PROGRAM', domainId: program.id, verb: 'MANAGE', subdomain: 'LEARNERS' })
      ),
    [programs, hasPermission]
  );
};
